/**
 * Booking terms enum.
 *
 * The term a booking is taken out on: ONE_OFF is a short term booking,
 * RECURRING_MONTHLY is a long term one.
 */
export const BOOKING_TERM = {
    ONE_OFF: 'one-off',
    RECURRING_MONTHLY: 'recurring-monthly',
};

let constants = {
    // User states
    USER_EXISTING: 0,
    USER_NEW: 1,

    // Booking dates
    LONG_TERM_DAY_OFFSET: 0,
    DEFAULT_LONG_TERM_DAY_OFFSET: 2,

    // Search
    HOMEPAGE_DEFAULT_RENTAL: screen.width > 480 ? 'long' : 'short',

    // Analytics
    ECOMMERCE_SHORT_TERM_COMMISSION_AMOUNT: 0.3,
};

export default constants;
